// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"5d184fe5","453":"889a7df3"}[chunkId] + ".chunk.js";
};